import * as React from 'react';
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews';
import { linkResolver } from './src/utils/linkResolver';

const repositoryConfigs = [
  {
    repositoryName: 'create-construct',
    linkResolver,
    componentResolver: {
      home_page: React.lazy(() => import('./src/pages/index')),
      about_page: React.lazy(() => import('./src/pages/about')),
      contact_page: React.lazy(() => import('./src/pages/contact')),
      journal_entry: React.lazy(() => import('./src/pages/news')),
      project: React.lazy(() => import('./src/templates/Project')),
      projects_portal: React.lazy(() => import('./src/pages/projects')),
      projects_under_construction: React.lazy(() => import('./src/pages/under-construction')),
      under_construction: React.lazy(() => import('./src/templates/UnderConstruction')),
    },
  },
];

export const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider repositoryConfigs={repositoryConfigs}>
    {element}
  </PrismicPreviewProvider>
);
